import React, { Dispatch, SetStateAction } from 'react';

import * as S from '../../styles';
import { ButtonSimple } from '../../../../../../../components/newStudent/Buttons';
import OldFiles from '../OldFiles';
import Input from '../Input';
import { IDocumentFiles } from '../../../..';
import { FileItem, NamedItem } from '../..';

interface Props {
  status: 'danger' | 'warning' | 'success';
  documentType: number;
  oldFiles: IDocumentFiles[] | [];
  setOldFiles: Dispatch<SetStateAction<IDocumentFiles[] | []>>;
  selectedFiles: FileItem[] | NamedItem[];
  setSelectedFiles: Dispatch<SetStateAction<FileItem[] | NamedItem[]>>;
  textToOpen: number | undefined;
  setTextToOpen: Dispatch<SetStateAction<number | undefined>>;
  setWasChanged: Dispatch<SetStateAction<boolean>>;
}
export default function DocumentsLayoutDesktop({
  status,
  documentType,
  oldFiles,
  setOldFiles,
  selectedFiles,
  setSelectedFiles,
  textToOpen,
  setTextToOpen,
  setWasChanged,
}: Props) {
  return (
    <S.ContentFocus>
      <S.StyledForm>
        {status !== 'success' &&
          selectedFiles.map((item, index) => (
            <S.InputFocus key={index}>
              <div style={{ width: '100%' }}>
                <Input
                  index={index}
                  item={item}
                  documentType={documentType}
                  setSelectedFiles={setSelectedFiles}
                  selectedFiles={selectedFiles}
                  setWasChanged={setWasChanged}
                />
              </div>
              <S.ObservationDiv></S.ObservationDiv>
            </S.InputFocus>
          ))}
        {oldFiles &&
          oldFiles.map((item: IDocumentFiles, index: number) => (
            <S.InputFocus key={index}>
              <div style={{ width: '100%' }}>
                <OldFiles
                  item={item}
                  index={index}
                  selectedFiles={selectedFiles}
                  setWasChanged={setWasChanged}
                  setSelectedFiles={setSelectedFiles}
                  documentType={documentType}
                  oldFiles={oldFiles}
                  setOldFiles={setOldFiles}
                  success={status === 'success'}
                />
              </div>
              <S.ObservationDiv
                className={textToOpen === item.id ? 'isOpen' : ''}
              >
                {item.observation ? (
                  <>
                    <S.ObservationText>{item.observation}</S.ObservationText>
                    {item.observation.length > 37 && (
                      <ButtonSimple
                        color="primary"
                        heightSize="small"
                        widthSize="xxsmall"
                        onClick={() =>
                          setTextToOpen(
                            textToOpen === item.id ? undefined : item.id,
                          )
                        }
                      >
                        {textToOpen !== item.id ? 'Ler' : 'Ocultar'}
                      </ButtonSimple>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </S.ObservationDiv>
            </S.InputFocus>
          ))}
      </S.StyledForm>
    </S.ContentFocus>
  );
}
